module.exports = __webpack_public_path__ + "img/ajuan_cuti.3099a247.png";